// src/App.js

import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import FAQ from "../Pages/FAQ";
import Terms from "../Pages/Terms";
import Privacy from "../Pages/Privacy";
import Home from "../Pages/Home";
import Landing from "../Pages/Landing";
import Login from "../Pages/Login";
import AuthForm from "../AuthForm";
import Upgrade from "../Pages/Upgrade";
import Launch from "../Pages/Launch";
import ForgotPassword from "../Pages/ForgotPassword";
import ForgotUsername from "../Pages/ForgotUsername";
import ResetPassword from "../Pages/ResetPassword";

import { supabase } from "../utils/supabaseClient";
import {
  SessionContextProvider,
  useSession,
  useSupabaseClient,
} from "@supabase/auth-helpers-react";

// Optional: Suppress logs in production
if (
  process.env.NODE_ENV !== "development" &&
  localStorage.getItem("vintari_debug") !== "true"
) {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.error = () => {};
}

function AuthCallbackHandler() {
  const supabase = useSupabaseClient();

  useEffect(() => {
    const handleAuth = async () => {
      const { error } = await supabase.auth.getSession();
      if (error) {
        console.error("Session error:", error);
      }
      window.location.href = "/";
    };

    handleAuth();
  }, [supabase]);

  return <div className="text-white text-center p-10">Confirming email…</div>;
}

function AppRoutes() {
  const session = useSession();
  const supabase = useSupabaseClient();
  const [profile, setProfile] = useState(null);

  const customToastOptions = {
  // Define styles for all toasts
  style: {
    background: '#1F2937', // A dark gray, similar to your UI
    color: '#FFFFFF',
    border: '1px solid #7c3aed', // Your accent purple
  },

  // Define styles for specific toast types
  error: {
    // This will apply to the "professional feature" message
    style: {
      background: '#1F2937',
      color: '#FFFFFF',
      border: '1px solid #7c3aed', // A contrasting pink/red for errors
    },
    iconTheme: {
      primary: '#7c3aed', // Icon color
      secondary: '#FFFFFF',
    },
  },
};

useEffect(() => {
    if (session?.user) {
      // 2. Fetch the profile when the user session exists
      supabase
        .from('profiles')
        .select('plan')
        .eq('id', session.user.id)
        .single()
        .then(({ data, error }) => {
          if (error) {
            console.error('Error fetching profile:', error);
          } else {
            // 3. Combine auth user data and profile data
            setProfile({
              ...session.user, // The original user data
              plan: data?.plan || 'free', // The plan from your profiles table
            });
          }
        });
    } else {
        // If there's no session, clear the profile
        setProfile(null);
    }
  }, [session, supabase]);


return (
    <>
      <Toaster position="top-right" reverseOrder={false}  toastOptions={customToastOptions} />
      <Routes>
        {/* 4. Pass the complete 'profile' object instead of 'user' */}
        <Route path="/" element={<Landing supabase={supabase} user={profile} />} />
        <Route path="/login" element={<Login />} />
        {/* Now the Home component will receive the user object with the correct plan */}
        <Route path="/app" element={session ? <Home user={profile} /> : <AuthForm />} />
        <Route path="/strategist" element={session ? <Home user={profile} /> : <AuthForm />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/upgrade" element={<Upgrade />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
<Route path="/forgot-username" element={<ForgotUsername />} />
<Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/launch" element={<Launch />} />
        <Route path="*" element={<div className="text-white p-10">404 Not Found</div>} />
      </Routes>
    </>
  );
}

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const showAuthCallback = urlParams.has("access_token");

  return (
    <SessionContextProvider supabaseClient={supabase}>
      <Router>
        {showAuthCallback ? <AuthCallbackHandler /> : <AppRoutes />}
      </Router>
    </SessionContextProvider>
  );
}

export default App;